module.exports = __webpack_public_path__ + "static/media/Banshee.b604c7f0.jpg";